import React from 'react';
import { Tooltip } from '@deephaven/components';
import { dhPython, vsCode, vsFolder, vsFolderOpened } from '@deephaven/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { isDirectory } from "./FileStorage.js";
import "./FileList.css";
import FileUtils, { MIME_TYPE } from "./FileUtils.js";
import { getPathFromItem } from "./FileListUtils.js";
/**
 * Get the icon definition for a file or folder item
 * @param item Item to get the icon for
 * @returns Icon definition to pass in the FontAwesomeIcon icon prop
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function getItemIcon(item) {
  if (isDirectory(item)) {
    return item.isExpanded ? vsFolderOpened : vsFolder;
  }
  var mimeType = FileUtils.getMimeType(item.basename);
  switch (mimeType) {
    case MIME_TYPE.PYTHON:
      return dhPython;
    default:
      return vsCode;
  }
}
export function FileListItem(props) {
  var _draggedItems$some;
  var children = props.children,
    draggedItems = props.draggedItems,
    isDragInProgress = props.isDragInProgress,
    isDropTargetValid = props.isDropTargetValid,
    isSelected = props.isSelected,
    item = props.item,
    itemIndex = props.itemIndex,
    dropTargetItem = props.dropTargetItem,
    _onDragStart = props.onDragStart,
    _onDragOver = props.onDragOver,
    _onDragEnd = props.onDragEnd,
    onDragExit = props.onDragExit,
    _onDrop = props.onDrop;
  var isDragged = (_draggedItems$some = draggedItems === null || draggedItems === void 0 ? void 0 : draggedItems.some(draggedItem => draggedItem.id === item.id)) !== null && _draggedItems$some !== void 0 ? _draggedItems$some : false;
  var itemPath = getPathFromItem(item);
  var dropTargetPath = isDragInProgress && dropTargetItem ? getPathFromItem(dropTargetItem) : null;
  var isExactDropTarget = isDragInProgress && isDropTargetValid && isDirectory(item) && dropTargetPath === itemPath;
  var isInDropTarget = isDragInProgress && isDropTargetValid && dropTargetPath === itemPath;
  var isInvalidDropTarget = isDragInProgress && !isDropTargetValid && dropTargetPath === itemPath;
  var icon = getItemIcon(item);
  var depth = FileUtils.getDepth(item.filename);
  var depthLines = Array(depth).fill(null).map((value, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _jsx("span", {
    className: "file-list-depth-line"
  }, index));
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('d-flex w-100 align-items-center', 'file-list-item', {
      'is-dragged': isDragged,
      'is-exact-drop-target': isExactDropTarget,
      'is-in-drop-target': isInDropTarget,
      'is-invalid-drop-target': isInvalidDropTarget,
      'is-selected': isSelected
    }),
    onDragStart: e => _onDragStart(itemIndex, e),
    onDragOver: e => _onDragOver(itemIndex, e),
    onDragEnd: e => _onDragEnd(itemIndex, e),
    onDragExit: onDragExit,
    onDrop: e => _onDrop(itemIndex, e),
    draggable: true,
    role: "presentation",
    "aria-label": item.basename,
    children: [depthLines, ' ', /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: icon,
      className: "item-icon",
      fixedWidth: true
    }), ' ', /*#__PURE__*/_jsx("span", {
      className: "truncation-wrapper",
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsxs(_Fragment, {
        children: [item.basename, /*#__PURE__*/_jsx(Tooltip, {
          children: item.basename
        })]
      })
    })]
  });
}
export default FileListItem;
//# sourceMappingURL=FileListItem.js.map